import React, { useState } from "react";

import Toast          from "_common/toast";
import { createPoll } from "_services/api/broadcast";

import Presentation from "./presentation";

const component = ( { toggleCreatePoll, broadcastId, pollsConfig } ) => {
	const [ options, setOptions ]   = useState ( [ "Yes", "No" ] );
	const [ question, setQuestion ] = useState ( "" );

	const closeCreatePollDrawer = () => {
		setQuestion ( "" );
		toggleCreatePoll ();
	};
	const handleQuestion        = e => {
		const word = e.target.value;

		if ( question.length === 0 && word === " " ) {
			return;
		}

		setQuestion ( word );
	};

	const handlePostPoll = async () => {
		// add checks of all fields entered before Api call
		// Api call to send a poll
		if ( !broadcastId ) {
			return;
		}

		const params = {
			sessionId : parseInt ( broadcastId ),
			title     : question,
			options
		};

		try {
			const res = await createPoll ( params );

			if ( res?.status === "success" ) {
				Toast.success ( "Poll Posted Successfully" );
				closeCreatePollDrawer ();
			}
		} catch ( e ) {
			Toast.error ( e.displayMsg );
		}

	};

	const handleAddOption = () => {
		setOptions ( [ ...options, "" ] );
	};

	const handleRemoveOption = idx => {
		const list = [ ...options ];

		list.splice ( idx, 1 );
		setOptions ( list );
	};

	const handleOptionChange = ( e, idx ) => {

		const { value } = e.target;
		const list      = [ ...options ];

		if ( list[idx].length === 0 && value === " " ) {
			return;
		}

		list[idx] = value;
		setOptions ( list );
	};

	return (
		<Presentation
			closeCreatePollDrawer = { closeCreatePollDrawer }
			handleAddOption       = { handleAddOption }
			handleOptionChange    = { handleOptionChange }
			handlePostPoll        = { handlePostPoll }
			handleQuestion        = { handleQuestion }
			handleRemoveOption    = { handleRemoveOption }
			options               = { options }
			pollsConfig           = { pollsConfig }
			question              = { question }
			toggleCreatePoll      = { toggleCreatePoll }
		/>
	);
};

export default component;